import { css } from 'styled-components';

export const sequencedAnimationDelay = (count, intensity) => {
	let value = '';

	for (let i = 1; i < count; ++i) {
		value += `&:nth-child(${i}) { animation-delay: ${(i - 1) * intensity}s; }`;
	}

	return css`
		${value}
	`;
};
